import React from 'react';
import { BaseBarChartStacked, ChartsLegendItem } from 'components/atoms/charts';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';
import Legend from './legend';
import Tooltip from './tooltip';
import { itemsMask } from './items-mask';

import type { RangeTypes } from 'infrastructure/enums';
import type { ISmsMetricData } from 'infrastructure/interfaces';

interface IProps {
  title: string;
  rangeType: RangeTypes;
  data: ISmsMetricData[];
  bars: string[];
  colors?: Record<string, string>;
  startTime: number;
  endTime: number;
  legends?: {
    label: string;
    value: string | number;
  }[];
}

const SmsMetricsBarChart: React.FC<IProps> = (props) => {
  const {
    title,
    rangeType,
    data,
    startTime,
    endTime,
    bars = [],
    legends = [],
    colors = {},
  } = props;

  const { t } = useTranslation();

  const items = itemsMask({
    data,
    rangeType,
    bars,
    startTime,
    endTime,
    colors,
  });

  return (
    <div className={s.wrapper}>
      <div className={s.title}>
        <span>{title}</span>
        <div className={s['title-legends']}>
          {legends.map((a) => (
            <Legend key={a.label} name={a.label} value={a.value} />
          ))}
        </div>
      </div>
      <div className={s.legends}>
        {t('labels.legend')}
        {items[0].bars.map((a) => (
          <ChartsLegendItem key={a.name} name={a.name} color={a.color} />
        ))}
      </div>

      <BaseBarChartStacked
        data={items}
        height={320}
        hoverBackgroundColor="#FB93181A"
        tooltip={Tooltip}
        xTickFormatter={(name) => {
          const hour = items.find((el) => el.name === name);
          if (hour && hour.hidden) return '';
          return name;
        }}
      />
    </div>
  );
};

export default SmsMetricsBarChart;
